module.exports = __webpack_public_path__ + "assets/img/101807.f6e340fa.svg";